// react library imports
import { motion } from "framer-motion";

// imports from utils
import { headingAnimation } from "Utils/animation";

const UserHeaderCard = ({title, description, logo}) => {
  return (
    <section className='mues_column_space_between mues_row_gap_8
    user_header_card_container'>
      <motion.div className='user_header_profile_container mues_row_center'
      variants={headingAnimation}>
          <img src={logo} alt="logo" loading="lazy" />
      </motion.div>
      <motion.h5 className='mues_black mues_font_weight_600' variants={headingAnimation}>{title}</motion.h5>
      <motion.h6 className='mues_grey_I mues_font_weight_400'
      variants={headingAnimation}>{description}</motion.h6>
    </section>
  )
}

export default UserHeaderCard